<template>
  <v-card>
    <v-form ref="form">
      <v-container>
        <div class="text-center">
          <h2>Student Details</h2>
        </div>
        <p>To be filled in by Parent/Guardian </p>
        <p>Please complete the form providing all the details.</p>
        <fieldset>

          <legend class="mt-5">Section 1: Student’s Details </legend>

          <v-row>

            <!-- First Name -->
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">First Name </label>
              <v-text-field required v-if="this.check == '1'" disabled :error-messages="errors.std_fname"
                v-model="data.std_fname" label="Student’s First Name" prepend-icon solo></v-text-field>
              <v-text-field required v-else :error-messages="errors.std_fname" v-model="data.std_fname"
                label="Student’s First Name" prepend-icon solo></v-text-field>
            </v-col>

            <!-- Sur Name -->
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Surname</label>
              <v-text-field required v-if="this.check == '1'" disabled v-model="data.std_surname"
                label="Student’s Surname" prepend-icon :error-messages="errors.std_surname" solo></v-text-field>
              <v-text-field required v-else v-model="data.std_surname" label="Student’s Surname" prepend-icon
                :error-messages="errors.std_surname" solo></v-text-field>
            </v-col>

            <!-- Date of Birth -->
            <v-col cols="12" sm="6" md="6" v-if="this.check == '1'">
              <label class="custom-label">Date Of Birth</label>
              <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="data.date"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field required disabled :error-messages="errors.date" v-model="data.date" label="Choose Date"
                    prepend-icon v-bind="attrs" solo v-on="on"></v-text-field>
                </template>
                <v-date-picker :first-day-of-week="1" v-model="data.date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(data.date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>


            <v-col cols="12" sm="6" md="6" v-else>
              <label class="custom-label">Date Of Birth</label>
              <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="data.date"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field required :error-messages="errors.date" v-model="joiningDateFormated" label="Choose Date"
                    prepend-icon v-bind="attrs" solo v-on="on"></v-text-field>
                </template>
                <v-date-picker :first-day-of-week="1" v-model="data.date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(data.date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Gender</label>
              <v-select required v-if="this.check == '1'" disabled :error-messages="errors.gender" v-model="data.gender"
                :items="gender" label="Choose Gender" placeholder="Choose Gender" solo single-line></v-select>
              <v-select required v-else :error-messages="errors.gender" v-model="data.gender" :items="gender"
                label="Choose Gender" placeholder="Choose Gender" solo single-line></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">School Name</label>
              <v-text-field v-model="data.currently_attending_school" label="School Name" prepend-icon
                :error-messages="errors.currently_attending_school" solo></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Year group (class)</label>
              <v-text-field required v-model="data.year_inSchool" label="Year In School" prepend-icon
                :error-messages="errors.year_inSchool" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Full Home Address</label>
              <v-text-field required :error-messages="errors.home_address" v-model="data.home_address"
                label="Home Address" prepend-icon solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Post Code</label>
              <v-text-field required :error-messages="errors.post_code" v-model="data.post_code" label="Post Code"
                prepend-icon solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label"> Student’s mobile number (if applicable)</label>
              <v-text-field required :error-messages="errors.std_mobile_num" v-model="data.std_mobile_num"
                label="Student’s mobile number (if applicable)" prepend-icon solo></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Student’s email address (if applicable)</label>
              <v-text-field required :error-messages="errors.std_email" v-model="data.std_email"
                label="Student’s email address (if applicable)" prepend-icon solo></v-text-field>
            </v-col>


          </v-row>
          <hr />
          <legend class="mt-5">Section 2: Parent/Guardian’s Details </legend>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Title</label>
              <v-select :items="parent_title_array" required :disabled="check == '1'"
                :error-messages="errors.parent_title" v-model="data.parent_title" label="Select Parent's Title"
                prepend-icon solo></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">First Name</label>
              <v-text-field required v-if="this.check == '1'" disabled :error-messages="errors.parent_fname"
                v-model="data.parent_fname" label="Parent's First Name" prepend-icon solo></v-text-field>
              <v-text-field required v-else :error-messages="errors.parent_fname" v-model="data.parent_fname"
                label="Parent's First Name" prepend-icon solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Surname</label>
              <v-text-field required v-if="this.check == '1'" disabled :error-messages="errors.parent_surname_name"
                v-model="data.parent_surname_name" label="Parent's Surname" prepend-icon solo></v-text-field>
              <v-text-field required v-else :error-messages="errors.parent_surname_name"
                v-model="data.parent_surname_name" label="Parent's Surname " prepend-icon solo></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Mobile telephone number</label>
              <v-text-field required v-model="data.mobile_number" label="Mobile Number" prepend-icon type="number"
                :error-messages="errors.mobile_number" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Home telephone number</label>
              <v-text-field v-model="data.home_contact_number" label="Home contact Number" prepend-icon
                :error-messages="errors.home_contact_number" type="number" solo></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Work telephone number</label>
              <v-text-field v-model="data.work_contact_number" label="Work contact Number" prepend-icon type="number"
                :error-messages="errors.work_contact_number" solo></v-text-field>
            </v-col>


            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Relationship To Child</label>
              <v-text-field v-if="this.check == '1'" disabled required v-model="data.relation_to_child"
                label="Relation To Child" prepend-icon :error-messages="errors.relation_to_child" solo></v-text-field>

              <v-text-field v-else required v-model="data.relation_to_child" label="Relation To Child" prepend-icon
                :error-messages="errors.relation_to_child" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">E-mail address</label>
              <v-text-field v-model="data.email_address" label="Email Address" type="email" prepend-icon
                :error-messages="errors.email_address" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Who is responsible for the child’s educational needs at home?</label>
              <v-text-field v-model="data.who_res_for_edu_need"
                label="Who is responsible for the child’s educational needs at home?" type="text" prepend-icon
                :error-messages="errors.who_res_for_edu_need" solo></v-text-field>
            </v-col>
          </v-row>
          <hr />
          <legend class="mt-5">Section 3: How will the student attend their lessons? (Choose one) </legend>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Lesson Mode</label>
              <v-select required v-model="data.take_class" :items="classes" :error-messages="errors.take_class"
                label="Choose Class " placeholder="Choose Class" solo single-line></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="6" v-if="data.take_class == 'In-Centre'">
              <label class="custom-label">Who will be responsible for picking up the child from the centre?</label>
              <v-text-field v-model="data.responsible" label="Who Is Responsible?" required prepend-icon
                :error-messages="errors.responsible" solo></v-text-field>

            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="data.take_class == 'In-Centre'">
              <p>If different from persons named above please inform the centre manager.</p>
            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="data.take_class == 'In-Centre'">
              <label class="custom-label"><b>Parent/carer consent for children to be allowed to walk home
                  alone</b></label>
              <p>In order to ensure children’s safety, only children in Years 5 and above are allowed to walk home on
                their own. To safeguard all young people at QS Learning, if you wish to take responsibility for your
                child making their own way home from the centre then we will require written permission from a
                parent/carer confirming this arrangement. </p>
              <p>If you would like your child to walk home alone, please complete the details below.</p>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pt-0 pb-0" v-if="data.take_class == 'In-Centre'">
              <label class="custom-label">Child's Name</label>
              <v-text-field v-model="data.childName" label="" prepend-icon :error-messages="errors.childName" solo>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="pt-0 pb-0" v-if="data.take_class == 'In-Centre'">
              <label class="custom-label">Year group</label>
              <v-text-field v-model="data.Year" label="" prepend-icon :error-messages="errors.Year" solo></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" class="pt-0 pb-5" v-if="data.take_class == 'In-Centre'">
              <label for="checkbox"><input required type="checkbox" v-model="data.child_go_alone" />
                I consent to my child being allowed to walk home alone from the QS Learning centre.
              </label>
            </v-col>
          </v-row>

          <v-row v-if="data.take_class == 'Online'">

            <v-col cols="12" sm="6" md="6">
              <label>Which web browser will they use?</label>
              <v-radio-group v-model="data.radioBrowserGroup">
                <v-radio label="Chrome" value="Chrome"></v-radio>
                <v-radio label="Fire fox" value="Fire_fox"></v-radio>
                <v-radio label="Apple" value="Apple"></v-radio>
                <v-radio label="Safari" value="Safari"></v-radio>
              </v-radio-group>
              <lable>Other (please specify) </lable>
              <v-text-field type="text" v-model="data.browser_other"></v-text-field>
              <lable>Internet Service Provider</lable>
              <v-text-field type="text" v-model="data.internet_service_provider"
                :error-messages="errors.internet_service_provider" solo></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">

              <lable>How will your child connect their device with the internet during the class? </lable>
              <v-radio-group v-model="data.radioMobileData">
                <v-radio label="Mobile Data" value="mobile_data"></v-radio>
                <v-radio label="Hotspot" value="Hotspot"></v-radio>
                <v-radio label="Wi-Fi" value="Wi-Fi"></v-radio>
                <v-radio label="Ethernet cable" value="Ethernet cable"></v-radio>
              </v-radio-group>
              <lable>Other (please specify) </lable>
              <v-text-field type="text" v-model="data.mobileDataOther"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">

              <label>Which device will the child use to take their lessons?</label>
              <br />
              <b>Note: Lessons cannot take place on the Smartphones</b>
              <v-radio-group v-model="data.radioDeviceUseForLesson" :error-messages="errors.radioDeviceUseForLesson"
                solo>
                <v-radio label="Desktop" value="Desktop"></v-radio>
                <v-radio label="Laptop" value="Laptop"></v-radio>
                <v-radio label="Tablet" value="Tablet"></v-radio>

              </v-radio-group>

            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label>Would your child like (tick one):</label>
              <v-radio-group v-model="data.radioCopiesGroup" :error-messages="errors.radioCopiesGroup" solo>
                <v-radio label="Hard copies (posted to you)" value="hard_copies"></v-radio>
                <v-radio label="Electronic Copies " value="electronic_copies"></v-radio>
              </v-radio-group>
              <label>of the teaching materials each month? </label>
            </v-col>
          </v-row>
          <v-row v-if="data.take_class == 'Online'">
            <v-col cols="12" sm="12" md="12">
              <p><b>Note</b> : For all online lessons to take place effectively please ensure that your child has access
                to the following: Fully charged device, Camera, Microphone, Headphones, Quiet study area and Good
                Lighting.</p>
            </v-col>
          </v-row>
          <fieldset>

            <hr />
            <legend class="mt-5">Section 4: Emergency contact details </legend>
            <h4 class="mt-2">Person 1:</h4>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <label class="custom-label">Name</label>
                <v-text-field required v-model="data.person_1_name" label="Name" :error-messages="errors.person_1_name"
                  prepend-icon solo></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <label class="custom-label">Contact Number</label>
                <v-text-field required v-model="data.person_1_contact" label="Contact Number" type="number"
                  :error-messages="errors.person_1_contact" prepend-icon solo></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <label class="custom-label">Relationship To Child</label>
                <v-text-field required v-model="data.person_1_relationship" label="Relationship To Child" prepend-icon
                  :error-messages="errors.person_1_relationship" solo></v-text-field>
              </v-col>
            </v-row>

            <h4>Person 2:</h4>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <label class="custom-label">Name</label>
                <v-text-field v-model="data.person_2_name" label="Name" prepend-icon
                  :error-messages="errors.person_2_name" solo></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <label class="custom-label">Contact Number</label>
                <v-text-field v-model="data.person_2_contact" label="Contact Number" type="number"
                  :error-messages="errors.person_2_contact" prepend-icon solo></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <label class="custom-label">Relationship To Child</label>
                <v-text-field v-model="data.person_2_relationship" label="Relationship To Child" prepend-icon
                  :error-messages="errors.person_2_relationship" solo></v-text-field>
              </v-col>
            </v-row>

            <h4>Person 3:</h4>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <label class="custom-label">Name</label>
                <v-text-field v-model="data.person_3_name" label="Name" prepend-icon
                  :error-messages="errors.person_3_name" solo></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <label class="custom-label">Contact Number</label>
                <v-text-field v-model="data.person_3_contact" label="Contact Number" type="number"
                  :error-messages="errors.person_3_contact" prepend-icon solo></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <label class="custom-label">Relationship To Child</label>
                <v-text-field v-model="data.person_3_relationship" label="Relationship To Child" prepend-icon
                  :error-messages="errors.person_3_relationship" solo></v-text-field>
              </v-col>
            </v-row>
          </fieldset>
          <hr />
          <legend class="mt-5">Section 5: Student information</legend>
          <v-row>

            <v-col cols="12" sm="12" md="12">
              <label class="custom-label">If applying for 11+ tuition please list all the schools in order of
                priority that your child would like to attend from September
              </label>
              <v-textarea v-model="data.list_of_school" label="List all schools priority wise" prepend-icon
                :error-messages="errors.list_of_school" solo></v-textarea>
            </v-col>

          </v-row>

          <hr />
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Does your child have any special educational needs?</label>
              <v-radio-group required :error-messages="errors.special_educational_needs"
                v-model="data.special_educational_needs" column>
                <v-radio label="Yes" :value="1"></v-radio>
                <v-radio label="No" :value="0"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="6" md="6" v-if="data.special_educational_needs == '1'">
              <label class="custom-label">Details</label>
              <v-text-field required :error-messages="errors.detail_of_special_needs"
                v-model="data.detail_of_special_needs" label="Details of Special Needs" prepend-icon solo>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" v-if="data.special_educational_needs == '1'">
              <label class="custom-label">Any Other Information</label>
              <v-text-field :error-messages="errors.other_detail_ofSpecialNeeds"
                v-model="data.other_detail_ofSpecialNeeds" label="Other Information" prepend-icon solo></v-text-field>
            </v-col>
          </v-row>

          <hr />
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <label class="custom-label">Please specify if there are any specific requirements you might have
                regarding English and Maths.</label>
              <v-textarea required :error-messages="errors.math_english_requirement"
                v-model="data.math_english_requirement" prepend-icon solo></v-textarea>
            </v-col>
          </v-row>

          <hr />
          <v-row v-if="data.take_class == 'In-Centre'">
            <v-col cols="12" sm="12" md="12">
              <label class="custom-label">Does the child have any food allergies or is the child in on any medication,
                please
                specify.
              </label>
              <v-textarea v-if="data.take_class == 'In-Centre'" :error-messages="errors.specify_food_allergy"
                v-model="data.specify_food_allergy" prepend-icon solo></v-textarea>
              <v-textarea v-else :error-messages="errors.specify_food_allergy" v-model="data.allergy" prepend-icon solo>
              </v-textarea>
            </v-col>
          </v-row>

          <hr />
          <legend class="mt-5"> Section 6: Siblings</legend>

          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Does your child have a brother or a sister attending QS Learning
                tuition?</label>
              <v-radio-group required :error-messages="errors.sibling_inQS" v-model="data.sibling_inQS" column>
                <v-radio label="Yes" :value="data.sibling_inQS == 1 ? 1 : 1"></v-radio>
                <v-radio label="No" :value="data.sibling_inQS == 0 ? 0 : 0"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" sm="6" md="6" v-if="data.sibling_inQS == '1'">
              <label class="custom-label">Full Name</label>
              <v-text-field required :error-messages="errors.name_of_siblingInQS" v-model="data.name_of_siblingInQS"
                label="Full Name" prepend-icon solo></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" v-if="data.sibling_inQS == '1'">
              <label class="custom-label">Date Of Birth</label>
              <v-text-field required :error-messages="errors.dob_siblingInQS" v-model="data.dob_siblingInQS"
                label="Choose Date" prepend-icon type="date" solo></v-text-field>
            </v-col>

          </v-row>

          <hr />
          <legend class="mt-5"> Section 7: Declaration</legend>
          <v-row>

            <v-col cols="12" sm="6" md="6" style="padding-bottom:0">
              <label class="custom-label">Parent Consent.</label>
              <v-text-field required :error-messages="errors.parent_consent" v-model="data.parent_consent"
                label="Parent Consent" prepend-icon solo></v-text-field>
            </v-col>
            <v-col style="padding-top:0" cols="12" sm="12" md="12" v-if="data.take_class == 'In-Centre'">
              <p>I give consent for my child to take part in the events taking place to help their learning. This would
                <br />include Christmas party food, photographs and some visits to relevant places.
              </p>
            </v-col>
          </v-row>
        </fieldset>

        <v-row>
          <v-col cols="12">
            <label for="checkbox"><input type="checkbox" style="cursor: pointer;" v-model="can_save" />

              <span class="ml-1">I confirm that I have read and agree to the QS Learning <a @click="terms">terms and
                  conditions.</a> I confirm that the information I have given on this form is true and that I have the
                legal responsibility and am the parent/guardian of the child named above. </span>
            </label>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn class="buttonPadding" color="#6A158E" v-if="can_save" @click="save()" dark>Save</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="800px">

        <v-card>
          <v-card-title>
            <v-row>

              <v-col cols="12" sm="12" md="12" class="text-right">
                <v-btn icon dark style="color: black;" @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>

            <embed
              src="https://admin.qslearning.co.uk/public/storage/terms&condition/terms&conditions.pdf#toolbar=0&navpanes=0&scrollbar=0"
              type="application/pdf" frameBorder="0" scrolling="auto" height="900px" width="100%" />

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>

</template>

<script>
import Form from "../../../utils/form/Form";
import moment from "moment";
export default {
  name: "Form",
  watch: {
    "data.date": function (newVal, oldVal) {
      console.log("newVal", newVal);
      this.joiningDateFormated = moment(this.data.date).format("DD-MM-YYYY");
    },
  },
  data() {
    return {
      dialog: false,
      can_save: false,
      joiningDateFormated: "",
      parent_title_array: ["Mr", "Miss", "Mrs"],
      success: false,
      successMsg: null,
      data: {
        childName: "",
        Year: "",
        child_go_alone: "",
        std_email: "",
        std_mobile_num: "",
        post_code: "",
        who_res_for_edu_need: "",
        radioDeviceUseForLesson: "",
        radioMobileData: "",
        radioCopiesGroup: "",
        radioBrowserGroup: "",
        browser_other: "",
        internet_service_provider: "",
        mobileDataOther: "",

        allergy: null,
        std_id: "",
        std_surname: "",
        std_fname: "",
        year_inSchool: "",
        home_address: "",
        gender: "",
        parent_title: "",
        parent_surname_name: "",
        parent_fname: "",
        home_contact_number: "",
        work_contact_number: "",
        mobile_number: "",
        relation_to_child: "",
        email_address: "",
        take_class: "",
        responsible: "",
        tution_class: "",
        person_1_name: "",
        person_1_contact: "",
        person_1_relationship: "",
        person_2_name: "",
        person_2_contact: "",
        person_2_relationship: "",
        person_3_name: "",
        person_3_contact: "",
        person_3_relationship: "",
        currently_attending_school: "",
        std_full_name: "",
        list_of_school: "",
        special_educational_needs: null,
        detail_of_special_needs: "",
        other_detail_ofSpecialNeeds: "",
        math_english_requirement: "",


        specify_food_allergy: this.allergy,
        sibling_inQS: "",
        name_of_siblingInQS: "",
        dob_siblingInQS: "",
        parent_consent: "",
        declaration: "",
        date: new Date().toISOString().substr(0, 10),
      },
      errors: {},
      menu: false,
      time: null,
      menu2: false,
      check: "0",
      gender: ["Male", "Female"],
      classes: ["Online", "In-Centre"],
    };
  },
  computed: {
    getBaseURL(url) {
      return window.baseURL;
    },
  },
  methods: {
    terms() {
      this.dialog = true;
    },
    setValues(student) {
      this.data.radioDeviceUseForLesson = student.radioDeviceUseForLesson;
      this.data.radioMobileData = student.radioMobileData;
      this.data.radioCopiesGroup = student.radioCopiesGroup;
      this.data.radioBrowserGroup = student.radioBrowserGroup;
      this.data.browser_other = student.browser_other;
      this.data.internet_service_provider = student.internet_service_provider;
      this.data.mobileDataOther = student.mobileDataOther;

      this.data.childName = student.childName;
      this.data.Year = student.Year;
      this.data.child_go_alone = student.child_go_alone;

      this.data.std_email = student.std_email;
      this.data.std_mobile_num = student.std_mobile_num;
      this.data.post_code = student.post_code;
      this.data.who_res_for_edu_need = student.who_res_for_edu_need;


      this.data.std_id = student.std_id;
      this.data.year_inSchool = student.year_inSchool;
      this.data.std_surname = student.std_surname;
      this.data.std_fname = student.std_fname;
      this.data.home_address = student.home_address;
      this.data.gender = student.gender;
      this.data.parent_title = student.parent_title;
      this.data.parent_surname_name = student.parent_surname_name;
      this.data.parent_fname = student.parent_fname;
      this.data.home_contact_number = student.home_contact_number;
      this.data.work_contact_number = student.work_contact_number;
      this.data.mobile_number = student.mobile_number;
      this.data.relation_to_child = student.relation_to_child;
      this.data.email_address = student.email_address;
      this.data.take_class = student.take_class;
      this.data.responsible = student.responsible;
      this.data.tution_class = student.tution_class;
      this.data.person_1_name = student.person_1_name;
      this.data.person_1_contact = student.person_1_contact;
      this.data.person_1_relationship = student.person_1_relationship;
      this.data.person_2_name = student.person_2_name;
      this.data.person_2_contact = student.person_2_contact;
      this.data.person_2_relationship = student.person_2_relationship;
      this.data.person_3_name = student.person_3_name;
      this.data.person_3_contact = student.person_3_contact;
      this.data.person_3_relationship = student.person_3_relationship;
      this.data.currently_attending_school = student.currently_attending_school;
      this.data.std_full_name = student.std_full_name;
      this.data.list_of_school = student.list_of_school;
      this.data.special_educational_needs = student.special_educational_needs;
      this.data.detail_of_special_needs = student.detail_of_special_needs;
      this.data.other_detail_ofSpecialNeeds = student.other_detail_ofSpecialNeeds;
      this.data.math_english_requirement = student.math_english_requirement;
      if (this.data.take_class == 'In-Centre') {
        this.data.specify_food_allergy = student.specify_food_allergy;
      }
      this.data.sibling_inQS = student.sibling_inQS;
      this.data.name_of_siblingInQS = student.name_of_siblingInQS;
      this.data.dob_siblingInQS = student.dob_siblingInQS;
      this.data.parent_consent = student.parent_consent;
      this.data.declaration = student.declaration;
      this.data.date = moment(student.date).format("DD-MM-YYYY");
    },
    save() {
      if (this.check == "1") {
        this.update();
      } else {
        this.create();
      }
    },

    getStudent() {
      axios.get(apiRoutes.AdmissionForm.check).then((response) => {
        if (response.data != 0) {
          this.check = "1";

          this.setValues(response.data);
        } else {
          this.check = "0";
        }
      });
    },
    update() {
      let form = new Form({
        ...this.data,
      });
      console.log(form)
      form
        .post(apiRoutes.AdmissionForm.update + "/" + this.data.std_id)
        .then((response) => {
          Toast.fire({
            icon: "success",
            title: "Form Update Successfully",

          });
          this.$router.replace({
            name: "StudentProfileSP",
          });
        })
        .catch((response) => {
          this.errors = response.data.errors ;
          Toast.fire({
            icon: "error",
            title: response.data.message
          });
        });
    },
    create() {
      let form = new Form({
        ...this.data,
      });
      form
        .post(apiRoutes.AdmissionForm.url)
        .then((response) => {
          Toast.fire({
            icon: "success",
            title: "Form Save Successfully",

          });
          this.$router.replace({
            name: "StudentProfileSP",
          });
          this.$refs.form.reset();
        })
        .catch((response) => {
          this.errors = response.data.errors ;
          Toast.fire({
            icon: "error",
            title: response.data.message
          });
        });
    },
  },
  created() {
    this.getStudent();
  },
};
</script>

<style lang="scss" scoped>
.buttonPadding {
  margin-bottom: 10px;
  cursor: pointer;
}

fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }
}
</style>
